import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common'; 
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';

import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';

import { PackSelectComponent } from './components/pack-select/pack-select.component';
import { CalculatorTypeComponent } from './components/calculator-type/calculator-type.component';
import { CalculatorComponent } from './components/calculator/calculator.component';
import { ResultComponent } from './components/result/result.component';
import { BurComponent } from './components/bur/bur.component';
import { ModalComponent } from './components/modal/modal.component';

import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { MySearchPipe } from './components/calculator/pipe';
import { DrawerComponent } from './components/drawer/drawer.component';
import { SummaryComponent } from './components/summary/summary.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { enterAnimation } from './animations/nav-animation';

@NgModule({
  declarations: [
    AppComponent,
    PackSelectComponent,
    CalculatorTypeComponent,
    CalculatorComponent,
    ResultComponent,
    SummaryComponent,
    MySearchPipe,
    DrawerComponent,
    NavbarComponent,
    BurComponent,
    ModalComponent,
  ],
  entryComponents: [],
  imports: [
    CommonModule,
    BrowserModule, 
    FormsModule,
    IonicModule.forRoot({
      navAnimation: enterAnimation,
      mode: 'md'
    }), 
    AppRoutingModule, 
    ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.production }),
    HttpClientModule,
    Ng2SearchPipeModule
  ],
  providers: [
    StatusBar,
    SplashScreen,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
